/**
 * Maintained by Sandon.
 */
<template>
  <div class="sy-tree-selector"
       :class="{'sy-tree-selector--mini': this.size === 'mini'}"
       :style="{height: fixHeight ? `${height}px` : 'auto'}"
       v-click-outside="{outside: _close, inside: _open}">
    <magic-input
      ref="magicInput"
      :multiple="multiple"
      :disabled="disabled"
      :filterable="filterable"
      :fixHeight="fixHeight"
      :visible="visible"
      :selectedTagsMaxHeight="selectedTagsMaxHeight"
      :filterPlaceholder="filterPlaceholder"
      :placeholder="placeholder"
      :text="firstNodeText"
      :completeText="firstNodeCompleteText"
      :size="size"
      :popperClass="popperClass"
      :popperWidth="popperWidth"
      @toggle="_toggleVisible"
      @clear="_singleClear"
      @filter="_filterUpdate($event, _nextUpdatePopper)"
      @popperWidth="_realPopperWidthUpdate">
      <el-tooltip
        v-for="node in showedSelectedNodes"
        :key="_getKey(node)"
        effect="light"
        :content="_getShowText(node, true)"
        placement="top"
        open-delay="500">
        <el-tag
          :closable="!disabled && !_nodeDisabled(node)"
          @close="_delTag(node)"
          type="info"
          :size="size"
          disable-transitions>
          {{_getShowText(node)}}
        </el-tag>
      </el-tooltip>
      <template slot="popper">
        <!--搜索候选列表-->
<!--        v-scrollbarPrettify-->
        <div
          v-if="filterKw.length"
          class="sy-tree-selector__filter-list-wrap"
          :style="{maxHeight: `${popperHeight}px`}">
          <filter-list
            :items="filterItems"
            :filterKw="filterKw"
            :remote-filter="remoteFilter"
            :isSelected="_isSelected"
            :width="realPopperWidth"
            @item-click="_clickFilterItem"
            @change="_filterItemsChange">
          </filter-list>
        </div>
        <!--下拉树形选择-->
        <div v-show="!filterKw.length" :style="{height: `${popperHeight}px`}" class="sy-tree-selector__tree-wrap">
          <tree
            ref="core"
            class="sy-tree-selector__tree"
            v-if="shouldTreeCreate"
            :visible="visible"
            :lazy="lazy"
            :load="load"
            :multiple="multiple"
            :data="data"
            :props="keys"
            :mustLeaf="mustLeaf"
            :mode="mode"
            :selected-keys.sync="realSelectedKeys"
            :expand-path="expandPath"
            :check-ancestor-fn="checkAncestorFn"
            :label-divider="labelDivider !== '/' ? labelDivider : showDivider"
            :progenyIndicator="progenyIndicator"
            @close="_close"
            @change="_changeHandler($event, false)"
            @silent-change="_changeHandler($event, true)"
            @checkbox-click="_checkboxClick">
          </tree>
        </div>
      </template>
    </magic-input>
  </div>

</template>

<script>
  import i18n from './i18n'
  import clickOutside from '../../../utils/click-outside'
  import MagicInput from '../magic-input'
  import FilterList from '../filter-list/index.vue'
  import Tree from '../tree'
  import selectorMixin from '../tree-model/selector-mixin'
  import PcSelectorMixin from '../tree-model/pc-selector-mixin'
  import {Modes} from '../tree-model'
  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'tree-selector',
    props: {
      // select框的placeholder
      placeholder: {type: String, default: pageText.pleaseChoose},
      // 是否多选
      multiple: {type: Boolean, default: false},
      // 是否只有叶子节点可选
      mustLeaf: {type: Boolean, default: false},
      // 是否固定高度
      fixHeight: {type: Boolean, default: false},
      // 左侧树的数据
      data: {type: Array},
      // 是否懒加载数据
      lazy: {type: Boolean, default: false},
      // 懒加载数据时的加载函数
      load: {type: Function},
      // 指定特定属性的 key 值，具体请看Readme
      props: Object,
      // 选中项文本，显示完整路径
      showComplete: {type: Boolean, default: false},
      // 选中条目展示分隔符，表示串起来的各节点的label的分隔字符，
      // 会影响 Node.completeLabel 值，也会在 'showComplete' 为true时影响选中项展示的文案
      labelDivider:{type: String, default: '/'},
      showDivider: {type: String, default: '/'}, // todo 废弃
      // popper 宽度
      popperWidth: {type: Number, default: 0},
      // dropdown 高度
      popperHeight: {type: Number, default: 280},
      // 初始选中的节点的id
      selectedKeys: {type: Array, default: () => []},
      // 需要配合selectedIds使用，并且两者一一对应；
      // 用于有初始数据+懒加载的场景，因为懒加载时有些初始的数据没法获取其label，`selectedData`用来指定每个id对应的label;
      // [{key: '', label: ''}]， 数组元素的键值是根据`props`来的；
      selectedData: {type: Array, default: () => []},
      // 初始半选的keys
      halfSelectedKeys: {type: Array, default: () => []},
      // 是否禁用
      disabled: {type: Boolean, default: false},
      // popperClass为浮层对应的类名
      popperClass: {type: String, default: ''},
      // size大小
      size: {type: String, default: 'small'},
      // 选中项展示时，最大的高度，超长会显示滚动条
      selectedTagsMaxHeight: {type: Number, default: 200},
      // 是否可进行搜索，如果需要远程搜索，配合`remoteFilter`使用，如果不设置`remoteFilter`，则会走默认本地搜索逻辑；
      filterable: {type: Boolean, default: false},
      // 远程搜索的自定义逻辑，懒加载时建议走远程搜索逻辑，异步获取数据时，此函数应为async函数或返回一个promise的函数；
      // 此函数的参数是搜索词，返回值数据格式为：
      // [{
      //   key: '',
      //   label: '',
      //   completeLabel: ''
      // }]
      remoteFilter: Function,
      // 过滤搜索时，输入框的placeholder
      filterPlaceholder: {type: String, default: pageText.search},
      // 被禁用的 keys，一般在"懒加载 + 有初始化数据"的场景使用
      disabledKeys: {type: Array, default: () => []},
      // 数据联动的模式，多选时使用
      mode: {type: String, default: Modes.TWO_WAY},
      // 自动展开, 自动展开路径上各节点的key(按顺序)
      expandPath: {type: Array, default: () => []},
      // 判断节点是否是选中节点的祖先，即此节点是否有"小点", (Node) => Boolean
      checkAncestorFn: {type: Function, default: null},
      // 是否展示有选中子孙节点的指示器（小蓝点）
      progenyIndicator: {type: Boolean, default: true},
      // 多选时搜索时，选中搜索项之后是否自动清除搜索词
      clearFilter: {type: Boolean, default: false}
    },
    directives: {
      'click-outside': clickOutside
    },
    components: {MagicInput, FilterList, Tree},
    mixins: [selectorMixin, PcSelectorMixin],
    data () {
      return {
        Modes
      }
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
  .sy-tree-selector{
    display: inline-block;
    line-height: 0;
    width: 100%;
  }
  .sy-tree-selector--mini {
    input {
      font-size: 12px;
    }
    input::-webkit-input-placeholder {
      color: #c0c4cc;
    }
    input:-moz-placeholder {
      color: #c0c4cc;
    }
    input::-moz-placeholder {
      color: #c0c4cc;
    }
    input::-ms-input-placeholder {
      color: #c0c4cc;
    }
  }
  .sy-tree-selector__filter-list-wrap{
    overflow: auto;
  }
  .sy-tree-selector__tree-wrap {
    box-sizing: border-box;
    overflow: auto;
    padding: 10px;
  }
  .sy-tree-selector__tree{
    height: 100%;
  }
</style>
